export default "/assets/images/big-sneeze2.74b50490a969f834.png";